import React from 'react';
import {useStickyState} from "@lb/mlib-components";

const PageContextZiggy = React.createContext({
    warehouse: '',
    search: '',
    updateWarehouse: (warehouse) => {
    },
    playing: true,
    play: () => {
    },
    pause: () => {
    },
});


export const PageContextZiggyProvider = (props) => {

    const [warehouse, setWarehouse] = useStickyState("ABBOTSFORD", "ziggyWarehouseState");
    const [playing, setPlaying] = useStickyState(true, 'ziggyPlaying');

    const [search, setSearch] = useStickyState('', 'ziggySearch');

    const updateSearchHandler = (title) => {
        setSearch(title);
    };

    const updateWarehouseHandler = (warehouse) => {
        setWarehouse(warehouse);
    };

    const playHandler = () => {
        setPlaying(true);
    };

    const pauseHandler = () => {
        setPlaying(false);
    };


    const contextValue = {
        warehouse: warehouse,
        search: search,
        updateSearch: updateSearchHandler,
        updateWarehouse: updateWarehouseHandler,
        playing: playing,
        play: playHandler,
        pause: pauseHandler,
    };

    return (
        <PageContextZiggy.Provider value={contextValue}>
            {props.children}
        </PageContextZiggy.Provider>
    );
};

export default PageContextZiggy;
